import { render, staticRenderFns } from "./PackageTransferReceipt.vue?vue&type=template&id=198c2310&"
import script from "./PackageTransferReceipt.vue?vue&type=script&lang=js&"
export * from "./PackageTransferReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports